import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconMagnifier1 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.906 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.608,23.707 C23.413,23.902 23.158,24.000 22.903,24.000 C22.648,24.000 22.393,23.902 22.199,23.707 L14.546,16.025 C13.011,17.258 11.069,18.000 8.956,18.000 C4.012,18.000 -0.011,13.963 -0.011,9.001 C-0.011,4.038 4.012,-0.000 8.956,-0.000 C13.900,-0.000 17.922,4.038 17.922,9.001 C17.922,11.122 17.183,13.071 15.955,14.611 L23.608,22.293 C23.997,22.683 23.997,23.317 23.608,23.707 ZM8.956,2.000 C5.110,2.000 1.982,5.141 1.982,9.001 C1.982,12.860 5.110,16.000 8.956,16.000 C12.801,16.000 15.930,12.860 15.930,9.001 C15.930,5.141 12.801,2.000 8.956,2.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconMagnifier1.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
